import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SummaryBase } from 'src/app/main/summary-base';
import { ProcessService } from 'src/app/service/process.service';
import { InstanceService } from 'src/app/service/instance.service';
import { AttributeService } from 'src/app/main/dynamic/service/attribute.service';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { SecurityService } from 'src/app/service/security.service';
import { AuthenticationService } from 'src/app/service/auth.service';
import { MaskApplierService } from 'ngx-mask';
import { CurrencyService } from 'src/app/service/currency.service';
import { DesignService } from 'src/app/service/design.service';

@Component({
  selector: "app-process-summary",
  templateUrl: "./process-summary.component.html",
  styleUrls: ["./process-summary.component.scss"],
})
export class ProcessSummaryComponent extends SummaryBase implements OnInit {

  @Input() totalColumns: number[];
  @Input() isCatalogView: boolean = false;
  private currencySrv: CurrencyService;

  constructor(
    attrService: AttributeService,
    processService: ProcessService,
    instanceService: InstanceService,
    router: Router,
    spinner: NgxSpinnerService,
    securityService: SecurityService,
    authService: AuthenticationService,
    maskService: MaskApplierService,
    currencyService: CurrencyService,
    private designService: DesignService
  ) {
    super(
      attrService,
      processService,
      instanceService,
      router,
      spinner,
      securityService,
      authService,
      maskService,
      currencyService
    );
    this.currencySrv = currencyService;
  }

  showButton: boolean;

  ngOnInit() {
    this.checkButtonVisibility();
    // o modo de visualização agora é controlado pelo pai via Input
  }

  checkButtonVisibility(): void {
    this.showButton = this.hasActions && this.getLinks().length > 0;
  }

  // resolveViewMode removido (controle feito no pai)

  getOptionByKey(attribute: AttributeModel, key: string): string {
    if (!attribute.options) {
      return "";
    }

    let opt = attribute.options.find(
      (option) => option.key.toLowerCase() == key.toLowerCase()
    );

    if (opt) {
      return opt.value;
    } else {
      return "";
    }
  }

  getOptionType(child: any, type: string): string {
    if (!child || !child.options) return null;

    let attribute = child.options.find((option) => option.key == type);

    if (attribute != undefined) return attribute.value;
    else return "false";
  }

  // Catalog helpers
  getCatalogImageUrl(): string {
    // Procura por atributos que possam representar imagem/thumbnail
    const imageAttr = this.findAttributeByOptionKeys(['image', 'imageurl', 'thumbnail', 'thumb'])
      || this.process?.attributes?.find(a => /imagem|foto|image|photo/i.test(a.key) && typeof a.value === 'string');

    const url = (imageAttr?.value || '').toString();
    if (url && (url.startsWith('http') || url.startsWith('/'))) {
      return url;
    }
    return null;
  }

  getCatalogPrice(): string {
    const priceAttr = this.process?.attributes?.find(a => {
      const maskOpt = a.options?.find(o => o.key?.toLowerCase() === 'mask');
      return maskOpt && (maskOpt.value?.toLowerCase() === 'currency' || maskOpt.value?.toLowerCase() === 'separator.2');
    });

    if (priceAttr?.value) {
      return this.currencySrv.formatCurrencyValue(priceAttr.value);
    }
    return null;
  }

  private findAttributeByOptionKeys(keys: string[]): AttributeModel | undefined {
    return this.process?.attributes?.find(a => a.options?.some(o => keys.includes(o.key?.toLowerCase())));
  }

  getTagAttributes(): AttributeModel[] {
    const attrs = this.process?.attributes || [];
    return attrs.filter(a => a?.options?.some(o => o.key?.toLowerCase() === 'labeltype' && o.value?.toLowerCase() === 'tag'));
  }

  onCardClick(event: MouseEvent): void {
    // Evita navegar quando o clique ocorrer dentro da área de ações (dropdown)
    const target = event.target as HTMLElement;
    if (target.closest('.catalog-card__actions')) {
      return; // deixa o bootstrap/jQuery tratar o dropdown normalmente
    }
    this.getLinkView();
  }
}
